import React from 'react';
import { Box, Divider, Drawer, IconButton, List, Toolbar } from '@mui/material';
import useToggle from 'hooks/useToggle';

import { ReactComponent as CloseIcon } from 'assets/icons/close-icon.svg';
import { ReactComponent as MenuIcom } from 'assets/icons/menu-icon.svg';
import GreetingBanner from 'components/greetingBanner/GreetingBanner';
import LanguageBar from 'components/languageBar/LanguageBar';
import LogoButton from 'components/logoButton/LogoButton';
import LogoutButton from 'components/logoutButton/LogoutButton';

const MobileMenu = (props) => {
    const { children, ownersName, toggleContactUsModal } = props;
    const [displayMobileMenu, toggleMobileMenu] = useToggle();

    return (
        <React.Fragment>
            <Toolbar className="navigation-bar-container">
                <LogoButton />
                <Toolbar className="mobile-navigation-bar">
                    <IconButton
                        aria-label="menu"
                        className="icons-container"
                        color="inherit"
                        edge="start"
                        onClick={toggleMobileMenu}
                    >
                        {displayMobileMenu ? <CloseIcon /> : <MenuIcom />}
                    </IconButton>
                </Toolbar>
            </Toolbar>
            <Drawer
                PaperProps={{
                    sx: {
                        top: '4.063rem',
                        width: '80%',
                    },
                }}
                SlideProps={{
                    timeout: {
                        enter: 500,
                        exit: 500,
                    },
                }}
                anchor="left"
                className="drawer-container"
                onClose={toggleMobileMenu}
                open={displayMobileMenu}
                style={{ zIndex: 100 }}
                variant="temporary"
            >
                <List className="drawer-list" component="nav">
                    {ownersName && (
                        <React.Fragment>
                            <GreetingBanner ownersName={ownersName} />
                            <Divider className="divider" flexItem orientation="horizontal" variant="middle" />
                        </React.Fragment>
                    )}
                    {children}
                    <Box className="logout-container">
                        <LanguageBar toggleContactUsModal={toggleContactUsModal} />
                        {children && (
                            <React.Fragment>
                                <Divider className="divider" flexItem orientation="horizontal" variant="fullWidth" />
                                <LogoutButton />
                            </React.Fragment>
                        )}
                    </Box>
                </List>
            </Drawer>
        </React.Fragment>
    );
};

export default MobileMenu;
